import React, { useState } from 'react'
import { dateInMDY } from '../Helper';
const Review = (props) => {
    const [img, setImg] = useState();
    const[imgpop, setImppop] = useState(false);
    const[preImage, setPreImage] = useState("");
    const[nextImage, setNextImage] = useState("");
    const[curImageArr, setcurImageArr] = useState("");

    let closepop =()=>{
        setImppop(!imgpop); 
        setPreImage("")
        setNextImage("")
    }
    let nextpreImage =(curImage)=>{
        let url = process.env.REACT_APP_IMAGE_URL+'review/';

        const index = curImageArr.findIndex((a) => a === curImage)

        
        if(curImage==='next'){
            setImg(url+nextImage);
        }else{
            setImg(url+preImage);
        }
        
    }

    const getPrevAndNext = (arr,activeID) => {
        const index = arr.findIndex((a) => a === activeID)
        console.log(index)
        if(arr.length>1){

            const prev = arr[index - 1];
            const next = arr[index + 1];

            if (prev === -1) {
                setPreImage('');
                setNextImage(next)
            }else{
                setPreImage(prev);
                setNextImage(next)
            }
           
        //return [prev, next]
        }
      }

    let imgurl = (attachment,current_image) => {
       // console.log('object',current_image)
        let url = process.env.REACT_APP_IMAGE_URL+'review/';
        setImg(url+current_image); 
       // attachment = JSON.parse(attachment);
        //console.log(attachment)
       // setcurImageArr(attachment);
       // getPrevAndNext(attachment,current_image)
        setImppop(!imgpop); 
    } 

    console.log(preImage,nextImage)
    //console.log(props?.reviews)
  return (
    <>
    <div className='reviews-container'>
        <span id='reviews-scroll'></span>
        <h5>Customer Reviews <strong>({props?.totCount})</strong></h5>
        <ul className='reviews'>
           {props?.reviews.map((e,i) => {
            return(
                <li key={i}>
                <div className='review'>
                <div className='rating-star'>{e.rating} <i className="fa-solid fa-star"></i></div>
                <p>{e.comment}</p>
                </div>                
                {JSON.parse(e.attachment).length > 0 && (
                    <div className='rating-img'>{JSON.parse(e.attachment).map((i,index) => {
                        return(
                        <span><img src={`${process.env.REACT_APP_IMAGE_URL}review/${i}`} alt={imgurl} onClick={()=>imgurl(e.attachment,i)} /></span>
                    )})}</div>
                    )}
                <div className='name-date'><span className='name'>{e.user_fullname}</span> <span className='date'>{dateInMDY(e.created_at)}</span></div>
            </li> 
            )
           })}
            
               
        </ul>
    </div>

                        
    <div className={`yt-img ${imgpop ? "show-video" : ""}`}>
        <div className="yt-img-overlay" onClick={closepop}><span className="close-btn"  ></span></div>
        <div className="yt-img-iframe"><img alt="" src={img} /></div>
        {/* {nextImage &&
        <div className='yt-next-arrow' onClick={()=>nextpreImage()}></div>
        }
        {preImage &&
        <div className='yt-prev-arrow' onClick={()=>nextpreImage()}></div>
        } */}
        
    </div>


    </>



  )
}

export default Review
